var $ = require('../../../../../../../webpack/node_modules/jquery');
var nunjucks = require('../../../../../../../webpack/node_modules/nunjucks');
require('../../../../../../../webpack/node_modules/jscroll');
redux = require('redux')
import 'url-search-params-polyfill';
let filteredItems = [];

$(document).ready(function(){
    if(/tx_form_formframework\[action\]/.test(window.location.search)) {
        $(".frame-type-form_formframework").parent().parent().children('#detail_accordeon_form_header.collapsed').click();
    }

    if($(".frame-type-form_formframework .form-control.error").length ) {
      $(".frame-type-form_formframework").parent().parent().children('#detail_accordeon_form_header.collapsed').click();
      setTimeout(function() {
        $(".frame-type-form_formframework .form-control.error").first()[0].scrollIntoView();
      }, 100)
    }

    createBookOptions();
    function createBookOptions() {
        $(".psr-events-book").each(function() {
            var title = $(this).data('title');
            var uid = $(this).data('uid');

            $('#eventform-singleselect-1, #eventanmeldungfranz-singleselect-1').each(function( index ) {
                $(this).append($('<option>', {
                    value: title,
                    "data-uid": uid,
                    text: title
                }));
            });
        });
    }

    $(".psr-events-book").click(function() {

        var uid = $(this).data('uid');

        $(".frame-type-form_formframework").parent().parent().children('#detail_accordeon_form_header.collapsed').click();

        $("#eventform-singleselect-1, #eventanmeldungfranz-singleselect-1").each(function( index ) {
            $(this).children("option[data-uid=" + uid + "]").prop('selected', true);
        });


        $([document.documentElement, document.body]).animate({
            scrollTop: $(".frame-type-form_formframework").parent().parent().children('#detail_accordeon_form_header').offset().top
        }, 2000);
    });

    if(typeof events === 'undefined') {
        return false;
    }

    nunjucks.configure('/template/dist/views-events', { autoescape: true });

    let scrollTimer, lastScrollFireTime = 0;
    const itemsContainer = $('.events-container__list-items');
    filteredItems = [];
    const categories = getCategories(events);
    const initialCount = 9;
    const loadValue = 6;

    events.map((event) => {
        event.tags = event.categories
            .filter(category => !categoriesExcludedFromTags.includes(category.uid))
            .map(category => category.title)
            .join(', ')

        event.lighthouse = event.categories
            .map(category => +category.uid)
            .flat()
            .some(catUid => catUid == 5)
    })

    /**
     * new redux store that manages the filter state
     */
    const store = redux.createStore(reducer)

    /**
     *
     * execute on state change of redux store
     * set active buttons
     * and render items
     */
    store.subscribe(() => {
        const filter = store.getState().filter;
        const page = store.getState().page;
        setActiveButtons(filter);
        setFilterClass(filter);
        filteredItems = sort(filterItems(filter), !!filter.size, page)

        var items = nunjucks.render('list-item.html.twig', {data: filteredItems, filteredItems: !!filter.size});
        itemsContainer.html(items);
    })

    $('.events-container__list-categories').html(
        nunjucks.render('list-item-categories.html.twig', {categories: categories, allLabel: labels[0]['all']})
    );
    store.dispatch({ type: 'filter', activeFilter: 'all'})

    /**
     *
     * button click => update redux store
     */
    $(document).on('click', '.event-category__item', function() {
        var activeFilter = $(this).data('category');
        store.dispatch({ type: 'filter', activeFilter: activeFilter})
    });

    $(window).on('scroll', function() {
        if($('.events-container__list-items').length && $('.events-container__list-items')[0].getBoundingClientRect().bottom - window.innerHeight <  100){
            store.dispatch({ type: 'page'})
        }

    });

    /**
     * manage state
     *
     * @param {{filter: Set<String|int>, page: int}} state
     * @param {{type: string, activeFilter: <String|int>}} action
     * @returns {{filter: Set<String|int>}}
     */
    function reducer (state = {filter: new Set([]), page: 0}, action) {
        return {
            filter: filterReducer(state.filter, action),
            page: pageReducer(state.page, action)
        }
        return state;
    }

    /**
     *
     * @param {Set<String|int>} filter
     * @param {Object} action
     * @returns {*}
     */
    function filterReducer(filter, action) {
        if(action.type === 'filter') {
            if(action.activeFilter === 'all') {
                filter = new Set([])
            } else {
                filter.has(action.activeFilter)
                    ? filter.delete(action.activeFilter)
                    : filter.add(action.activeFilter)
                filter = new Set([...filter])
            }
        }
        return filter
    }

    /**
     *
     * @param {int} page
     * @param {Object} action
     */
    function pageReducer(page, action) {
        if(action.type == 'page') {
            page++
        } else if(action.type == 'filter') {
            page = 0
        }
        return page
    }


    /**
     * set active classes of buttons
     * no filter category == all
     *
     * @param {Set<any>}filter
     */
    function setActiveButtons(filter) {
        $('.filter-buttons button').removeClass('active');
        if(!filter.size) {
            $('.filter-buttons .all').addClass('active');
        } else {
            $('.filter-buttons button').filter((i, button) => {
                return filter.has($(button).data('category'))
            }).addClass('active')
        }
    }


    /**
     * set filter class for list
     * no filter category == all
     *
     * @param {Set<any>}filter
     */
    function setFilterClass(filter) {
        $('.events-container-list-items').removeClass('filtered');
        if(filter.size) {
            $('.events-container-list-items').addClass('filtered');
        }
    }

    /**
     * filter items by category
     * no filter category == all
     *
     * @param {Set<any>}filter
     * @returns {Array<Object>}
     */
    function filterItems(filter) {
        if(!filter.size) {
            return events.slice()
        }

        return events.slice()
            .filter(event => {
                return event.categories.map(category => +category.uid)
                    .some(categoryUid => filter.has(categoryUid))
            })
    }

    /**
     *
     * @param {Array<Object>} events
     * @returns {Array<Object>}
     */
    function sort (events, filter, page) {
        let sortedEvents = events.sort((a,b) => a.tstamp - b.tstamp)
        if(!!filter) {
            return sortedEvents.slice(0, initialCount + page * loadValue)
        }

        let lightHouses = sortedEvents.filter(event => event.lighthouse).splice(0,2)
        let nonLightHouses = sortedEvents.filter(event => !lightHouses.includes(event))
        let offset = lightHouses.length ? 2 : 0
        return lightHouses
            .concat(nonLightHouses)
            .slice(0, initialCount + page * loadValue + offset)
    }

    /**
     *
     * @param events
     * @returns {Array<Object>}
     */
    function getCategories(events) {
        const categories = []
        events.map(event => event.categories)
            .flat()
            .filter(category => window.filterCategories.events.includes(+category.uid))
            .map(category => categories[+category.uid] = category.title)
        return categories
    }
});


